// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_module = require("rescript/lib/js/caml_module.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");

function areEnoughChildPropertiesToSurfaceOutOfAnchorNode(innerContent) {
  return innerContent.length > 5;
}

var AnchorContainingManyProperties = {
  manyThresholdCount: 5,
  areEnoughChildPropertiesToSurfaceOutOfAnchorNode: areEnoughChildPropertiesToSurfaceOutOfAnchorNode
};

var EdgeCases = {
  AnchorContainingManyProperties: AnchorContainingManyProperties
};

var RecordPropertySchema = Caml_module.init_mod([
      "DataExtraction__DataRecord__Schema__Types.re",
      50,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "fromProperty"
        ],
        [
          /* Function */0,
          "doesMatchProperty"
        ]
      ]
    });

var DataNodeSchema = Caml_module.init_mod([
      "DataExtraction__DataRecord__Schema__Types.re",
      151,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "value_encode"
        ],
        [
          /* Function */0,
          "value_decode"
        ],
        [
          /* Function */0,
          "map"
        ],
        [
          /* Function */0,
          "fromDataNode"
        ],
        [
          /* Function */0,
          "doesMatchDataNode"
        ],
        [
          /* Function */0,
          "doesContainSameValue"
        ],
        [
          /* Function */0,
          "allNodesWithPath"
        ]
      ]
    });

var LinkSchema = Caml_module.init_mod([
      "DataExtraction__DataRecord__Schema__Types.re",
      469,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "fromLinkNode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    });

var HeadlineSchema = Caml_module.init_mod([
      "DataExtraction__DataRecord__Schema__Types.re",
      511,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "fromHeadlineNode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    });

var ButtonSchema = Caml_module.init_mod([
      "DataExtraction__DataRecord__Schema__Types.re",
      555,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "fromButtonNode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    });

var ArraySchema = Caml_module.init_mod([
      "DataExtraction__DataRecord__Schema__Types.re",
      608,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "fromArrayNode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    });

var RecordSchema = Caml_module.init_mod([
      "DataExtraction__DataRecord__Schema__Types.re",
      696,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "fromRecord"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    });

function t_encode(encoder_dataSchema, v) {
  return Js_dict.fromArray([
              [
                "friendlyName",
                Decco.optionToJson(Decco.stringToJson, v.friendlyName)
              ],
              [
                "dataSchema",
                Curry._1(encoder_dataSchema, v.dataSchema)
              ]
            ]);
}

function t_decode(decoder_dataSchema, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var friendlyName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "friendlyName"), null));
  if (friendlyName.TAG === /* Ok */0) {
    var dataSchema = Curry._1(decoder_dataSchema, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataSchema"), null));
    if (dataSchema.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                friendlyName: friendlyName._0,
                dataSchema: dataSchema._0
              }
            };
    }
    var e = dataSchema._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".dataSchema" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = friendlyName._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".friendlyName" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function fromProperty(valueFromDataNode, makeDataSchema, param) {
  var func = Curry._1(DataNodeSchema.fromDataNode, valueFromDataNode);
  return {
          friendlyName: param.friendlyName,
          dataSchema: Curry._2(func, makeDataSchema, param.dataNode)
        };
}

function doesMatchProperty(param, valueFromDataSchema, valueFromDataNode, tagPathInfoFromSchema, tagPathInfoFromNode, param$1) {
  return Curry._6(DataNodeSchema.doesMatchDataNode, param.dataSchema, valueFromDataSchema, valueFromDataNode, tagPathInfoFromSchema, tagPathInfoFromNode, param$1.dataNode);
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "fromProperty"
        ],
        [
          /* Function */0,
          "doesMatchProperty"
        ]
      ]
    }, RecordPropertySchema, {
      t_encode: t_encode,
      t_decode: t_decode,
      fromProperty: fromProperty,
      doesMatchProperty: doesMatchProperty
    });

function value_encode(encoder_dataSchema, v) {
  if (typeof v === "number") {
    switch (v) {
      case /* PlainText */0 :
          return ["PlainText"];
      case /* Image */1 :
          return ["Image"];
      case /* LinkContainingManyProperties */2 :
          return ["LinkContainingManyProperties"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* Link */0 :
          return [
                  "Link",
                  Curry._2(LinkSchema.t_encode, encoder_dataSchema, v._0)
                ];
      case /* Headline */1 :
          return [
                  "Headline",
                  Curry._2(HeadlineSchema.t_encode, encoder_dataSchema, v._0)
                ];
      case /* Button */2 :
          return [
                  "Button",
                  Curry._2(ButtonSchema.t_encode, encoder_dataSchema, v._0)
                ];
      case /* Array */3 :
          return [
                  "Array",
                  Curry._2(ArraySchema.t_encode, encoder_dataSchema, v._0)
                ];
      
    }
  }
}

function value_decode(decoder_dataSchema, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Array" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._2(ArraySchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Array */3,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Button" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._2(ButtonSchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Button */2,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Headline" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Curry._2(HeadlineSchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Headline */1,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "Image" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Image */1
                  };
          }
      case "Link" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Curry._2(LinkSchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Link */0,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "LinkContainingManyProperties" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* LinkContainingManyProperties */2
                  };
          }
      case "PlainText" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PlainText */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function map(mapSchema, dataSchema) {
  return Curry._2(mapSchema, dataSchema, (function (value) {
                var f = function (param) {
                  return map(mapSchema, param);
                };
                if (typeof value === "number") {
                  switch (value) {
                    case /* PlainText */0 :
                        return /* PlainText */0;
                    case /* Image */1 :
                        return /* Image */1;
                    case /* LinkContainingManyProperties */2 :
                        return /* LinkContainingManyProperties */2;
                    
                  }
                } else {
                  switch (value.TAG | 0) {
                    case /* Link */0 :
                        return {
                                TAG: /* Link */0,
                                _0: Curry._2(LinkSchema.map, f, value._0)
                              };
                    case /* Headline */1 :
                        return {
                                TAG: /* Headline */1,
                                _0: Curry._2(HeadlineSchema.map, f, value._0)
                              };
                    case /* Button */2 :
                        return {
                                TAG: /* Button */2,
                                _0: Curry._2(ButtonSchema.map, f, value._0)
                              };
                    case /* Array */3 :
                        return {
                                TAG: /* Array */3,
                                _0: Curry._2(ArraySchema.map, mapSchema, value._0)
                              };
                    
                  }
                }
              }));
}

function fromDataNode(valueFromDataNode, makeDataSchema, dataNode) {
  var _url = Curry._1(valueFromDataNode, dataNode);
  var tmp;
  switch (_url.TAG | 0) {
    case /* PlainText */0 :
        tmp = /* PlainText */0;
        break;
    case /* Image */1 :
        tmp = /* Image */1;
        break;
    case /* Link */2 :
        var func = Curry._1(LinkSchema.fromLinkNode, valueFromDataNode);
        tmp = {
          TAG: /* Link */0,
          _0: Curry._2(func, makeDataSchema, _url._0)
        };
        break;
    case /* LinkContainingManyProperties */3 :
        tmp = /* LinkContainingManyProperties */2;
        break;
    case /* Headline */4 :
        var func$1 = Curry._1(HeadlineSchema.fromHeadlineNode, valueFromDataNode);
        tmp = {
          TAG: /* Headline */1,
          _0: Curry._2(func$1, makeDataSchema, _url._0)
        };
        break;
    case /* Button */5 :
        var func$2 = Curry._1(ButtonSchema.fromButtonNode, valueFromDataNode);
        tmp = {
          TAG: /* Button */2,
          _0: Curry._2(func$2, makeDataSchema, _url._0)
        };
        break;
    case /* Array */6 :
        var func$3 = Curry._1(ArraySchema.fromArrayNode, valueFromDataNode);
        tmp = {
          TAG: /* Array */3,
          _0: Curry._2(func$3, makeDataSchema, _url._0)
        };
        break;
    
  }
  return Curry._2(makeDataSchema, dataNode, tmp);
}

function doesMatchDataNode(dataSchema, valueFromDataSchema, valueFromDataNode, tagPathInfoFromSchema, tagPathInfoFromNode, dataNode) {
  var doesMatchDataNodeValue = function (dataSchemaValue, dataNodeValue) {
    var innerSchemas;
    var innerNodes;
    if (typeof dataSchemaValue === "number") {
      switch (dataSchemaValue) {
        case /* PlainText */0 :
            if (dataNodeValue.TAG === /* PlainText */0) {
              return true;
            } else {
              return false;
            }
        case /* Image */1 :
            if (dataNodeValue.TAG === /* Image */1) {
              return true;
            } else {
              return false;
            }
        case /* LinkContainingManyProperties */2 :
            if (dataNodeValue.TAG === /* LinkContainingManyProperties */3) {
              return true;
            } else {
              return false;
            }
        
      }
    } else {
      switch (dataSchemaValue.TAG | 0) {
        case /* Link */0 :
            if (dataNodeValue.TAG !== /* Link */2) {
              return false;
            }
            innerSchemas = dataSchemaValue._0.innerContent;
            innerNodes = dataNodeValue._0.innerContent;
            break;
        case /* Headline */1 :
            var match = dataSchemaValue._0;
            var innerSchemas$1 = match.innerContent;
            if (dataNodeValue.TAG !== /* Headline */4) {
              return false;
            }
            var match$1 = dataNodeValue._0;
            var innerNodes$1 = match$1.innerContent;
            if (match.hLevel === match$1.hLevel && innerSchemas$1.length === innerNodes$1.length) {
              return Belt_Array.every(Belt_Array.zip(innerSchemas$1, innerNodes$1), (function (param) {
                            return doesMatchDataNodeValue(Curry._1(valueFromDataSchema, param[0]), Curry._1(valueFromDataNode, param[1]));
                          }));
            } else {
              return false;
            }
        case /* Button */2 :
            if (dataNodeValue.TAG !== /* Button */5) {
              return false;
            }
            innerSchemas = dataSchemaValue._0.innerContent;
            innerNodes = dataNodeValue._0.innerContent;
            break;
        case /* Array */3 :
            var arraySchema = dataSchemaValue._0;
            if (dataNodeValue.TAG !== /* Array */6) {
              return false;
            }
            var arrayNode = dataNodeValue._0;
            if (typeof arraySchema === "number") {
              if (arraySchema === /* PlainTexts */0) {
                if (arrayNode.TAG === /* PlainTexts */0) {
                  return true;
                } else {
                  return false;
                }
              } else if (arrayNode.TAG === /* Images */1) {
                return true;
              } else {
                return false;
              }
            }
            switch (arraySchema.TAG | 0) {
              case /* Links */0 :
                  if (arrayNode.TAG !== /* Links */2) {
                    return false;
                  }
                  var dataSchemaValue$1 = {
                    TAG: /* Link */0,
                    _0: arraySchema._0
                  };
                  return Belt_Array.every(Belt_Array.map(arrayNode._0, (function (linkNode) {
                                    return {
                                            TAG: /* Link */2,
                                            _0: linkNode
                                          };
                                  })), (function (param) {
                                return doesMatchDataNodeValue(dataSchemaValue$1, param);
                              }));
              case /* Headlines */1 :
                  if (arrayNode.TAG !== /* Headlines */3) {
                    return false;
                  }
                  var dataSchemaValue$2 = {
                    TAG: /* Headline */1,
                    _0: arraySchema._0
                  };
                  return Belt_Array.every(Belt_Array.map(arrayNode._0, (function (headlineNode) {
                                    return {
                                            TAG: /* Headline */4,
                                            _0: headlineNode
                                          };
                                  })), (function (param) {
                                return doesMatchDataNodeValue(dataSchemaValue$2, param);
                              }));
              case /* Buttons */2 :
                  if (arrayNode.TAG !== /* Buttons */4) {
                    return false;
                  }
                  var dataSchemaValue$3 = {
                    TAG: /* Button */2,
                    _0: arraySchema._0
                  };
                  return Belt_Array.every(Belt_Array.map(arrayNode._0, (function (buttonNode) {
                                    return {
                                            TAG: /* Button */5,
                                            _0: buttonNode
                                          };
                                  })), (function (param) {
                                return doesMatchDataNodeValue(dataSchemaValue$3, param);
                              }));
              case /* Records */3 :
                  var propertySchemas = arraySchema._0.properties;
                  if (arrayNode.TAG === /* Records */5) {
                    return Belt_Array.every(arrayNode._0, (function (param) {
                                  var properties = param.properties;
                                  if (propertySchemas.length === properties.length) {
                                    return Belt_Array.every(Belt_Array.zip(propertySchemas, properties), (function (param) {
                                                  return Curry._6(RecordPropertySchema.doesMatchProperty, param[0], valueFromDataSchema, valueFromDataNode, tagPathInfoFromSchema, tagPathInfoFromNode, param[1]);
                                                }));
                                  } else {
                                    return false;
                                  }
                                }));
                  } else {
                    return false;
                  }
              
            }
        
      }
    }
    if (innerSchemas.length === innerNodes.length) {
      return Belt_Array.every(Belt_Array.zip(innerSchemas, innerNodes), (function (param) {
                    return doesMatchDataNodeValue(Curry._1(valueFromDataSchema, param[0]), Curry._1(valueFromDataNode, param[1]));
                  }));
    } else {
      return false;
    }
  };
  if (tagPathInfoFromSchema !== undefined && tagPathInfoFromNode !== undefined && !Caml_obj.caml_equal(Curry._1(tagPathInfoFromSchema, dataSchema), Curry._1(tagPathInfoFromNode, dataNode))) {
    return false;
  } else {
    return doesMatchDataNodeValue(Curry._1(valueFromDataSchema, dataSchema), Curry._1(valueFromDataNode, dataNode));
  }
}

function doesContainSameValue(dataSchema1, valueFromDataSchema, tagPathInfoFromSchema, dataSchema2) {
  var equalsDataSchemaValue = function (dataSchemaValue1, dataSchemaValue2) {
    var innerContent1;
    var innerContent2;
    if (typeof dataSchemaValue1 === "number") {
      switch (dataSchemaValue1) {
        case /* PlainText */0 :
            return dataSchemaValue2 === 0;
        case /* Image */1 :
            return dataSchemaValue2 === 1;
        case /* LinkContainingManyProperties */2 :
            if (typeof dataSchemaValue2 === "number") {
              return dataSchemaValue2 >= 2;
            } else {
              return false;
            }
        
      }
    } else {
      switch (dataSchemaValue1.TAG | 0) {
        case /* Link */0 :
            if (typeof dataSchemaValue2 === "number") {
              return false;
            }
            if (dataSchemaValue2.TAG !== /* Link */0) {
              return false;
            }
            innerContent1 = dataSchemaValue1._0.innerContent;
            innerContent2 = dataSchemaValue2._0.innerContent;
            break;
        case /* Headline */1 :
            var match = dataSchemaValue1._0;
            var innerContent1$1 = match.innerContent;
            if (typeof dataSchemaValue2 === "number") {
              return false;
            }
            if (dataSchemaValue2.TAG !== /* Headline */1) {
              return false;
            }
            var match$1 = dataSchemaValue2._0;
            var innerContent2$1 = match$1.innerContent;
            if (match.hLevel === match$1.hLevel && innerContent1$1.length === innerContent2$1.length) {
              return Belt_Array.every(Belt_Array.zip(innerContent1$1, innerContent2$1), (function (param) {
                            return equalsDataSchemaValue(Curry._1(valueFromDataSchema, param[0]), Curry._1(valueFromDataSchema, param[1]));
                          }));
            } else {
              return false;
            }
        case /* Button */2 :
            if (typeof dataSchemaValue2 === "number") {
              return false;
            }
            if (dataSchemaValue2.TAG !== /* Button */2) {
              return false;
            }
            innerContent1 = dataSchemaValue1._0.innerContent;
            innerContent2 = dataSchemaValue2._0.innerContent;
            break;
        case /* Array */3 :
            if (typeof dataSchemaValue2 === "number" || dataSchemaValue2.TAG !== /* Array */3) {
              return false;
            } else {
              return Caml_obj.caml_equal(dataSchemaValue1._0, dataSchemaValue2._0);
            }
        
      }
    }
    if (innerContent1.length === innerContent2.length) {
      return Belt_Array.every(Belt_Array.zip(innerContent1, innerContent2), (function (param) {
                    return equalsDataSchemaValue(Curry._1(valueFromDataSchema, param[0]), Curry._1(valueFromDataSchema, param[1]));
                  }));
    } else {
      return false;
    }
  };
  if (tagPathInfoFromSchema !== undefined && !Caml_obj.caml_equal(Curry._1(tagPathInfoFromSchema, dataSchema1), Curry._1(tagPathInfoFromSchema, dataSchema2))) {
    return false;
  } else {
    return equalsDataSchemaValue(Curry._1(valueFromDataSchema, dataSchema1), Curry._1(valueFromDataSchema, dataSchema2));
  }
}

function allNodesWithPath(dataSchema, valueFromDataSchema) {
  var collectNodesWithPath = function (currentPathOpt, dataSchema) {
    var currentPath = currentPathOpt !== undefined ? currentPathOpt : [];
    var collectNodesFromChildNode = function (childNode) {
      return collectNodesWithPath(Belt_Array.concat(currentPath, [dataSchema]), childNode);
    };
    var match = Curry._1(valueFromDataSchema, dataSchema);
    var tmp;
    var exit = 0;
    if (typeof match === "number") {
      tmp = [];
    } else {
      switch (match.TAG | 0) {
        case /* Headline */1 :
            var innerContent = match._0.innerContent;
            tmp = ArrayUtils$SmartcutsMacros.flatMap(collectNodesFromChildNode, innerContent);
            break;
        case /* Link */0 :
        case /* Button */2 :
            exit = 1;
            break;
        case /* Array */3 :
            var match$1 = match._0;
            var exit$1 = 0;
            if (typeof match$1 === "number") {
              tmp = match$1 === /* PlainTexts */0 ? [] : [];
            } else {
              switch (match$1.TAG | 0) {
                case /* Headlines */1 :
                    var innerContent$1 = match$1._0.innerContent;
                    tmp = ArrayUtils$SmartcutsMacros.flatMap(collectNodesFromChildNode, innerContent$1);
                    break;
                case /* Links */0 :
                case /* Buttons */2 :
                    exit$1 = 2;
                    break;
                case /* Records */3 :
                    tmp = ArrayUtils$SmartcutsMacros.flatMap((function (param) {
                            return collectNodesFromChildNode(param.dataSchema);
                          }), match$1._0.properties);
                    break;
                
              }
            }
            if (exit$1 === 2) {
              var innerContent$2 = match$1._0.innerContent;
              tmp = ArrayUtils$SmartcutsMacros.flatMap(collectNodesFromChildNode, innerContent$2);
            }
            break;
        
      }
    }
    if (exit === 1) {
      var innerContent$3 = match._0.innerContent;
      tmp = ArrayUtils$SmartcutsMacros.flatMap(collectNodesFromChildNode, innerContent$3);
    }
    return Belt_Array.concat([[
                  dataSchema,
                  currentPath
                ]], tmp);
  };
  return collectNodesWithPath(undefined, dataSchema);
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "value_encode"
        ],
        [
          /* Function */0,
          "value_decode"
        ],
        [
          /* Function */0,
          "map"
        ],
        [
          /* Function */0,
          "fromDataNode"
        ],
        [
          /* Function */0,
          "doesMatchDataNode"
        ],
        [
          /* Function */0,
          "doesContainSameValue"
        ],
        [
          /* Function */0,
          "allNodesWithPath"
        ]
      ]
    }, DataNodeSchema, {
      value_encode: value_encode,
      value_decode: value_decode,
      map: map,
      fromDataNode: fromDataNode,
      doesMatchDataNode: doesMatchDataNode,
      doesContainSameValue: doesContainSameValue,
      allNodesWithPath: allNodesWithPath
    });

function t_encode$1(encoder_dataSchema, v) {
  return Js_dict.fromArray([[
                "innerContent",
                Decco.arrayToJson(encoder_dataSchema, v.innerContent)
              ]]);
}

function t_decode$1(decoder_dataSchema, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var innerContent = Decco.arrayFromJson(decoder_dataSchema, Belt_Option.getWithDefault(Js_dict.get(dict._0, "innerContent"), null));
  if (innerContent.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              innerContent: innerContent._0
            }
          };
  }
  var e = innerContent._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".innerContent" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function fromLinkNode(valueFromDataNode, makeDataSchema, param) {
  return {
          innerContent: Belt_Array.map(param.innerContent, Curry._2(DataNodeSchema.fromDataNode, valueFromDataNode, makeDataSchema))
        };
}

function map$1(f, param) {
  return {
          innerContent: Belt_Array.map(param.innerContent, f)
        };
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "fromLinkNode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    }, LinkSchema, {
      t_encode: t_encode$1,
      t_decode: t_decode$1,
      fromLinkNode: fromLinkNode,
      map: map$1
    });

function t_encode$2(encoder_dataSchema, v) {
  return Js_dict.fromArray([
              [
                "hLevel",
                Decco.stringToJson(v.hLevel)
              ],
              [
                "innerContent",
                Decco.arrayToJson(encoder_dataSchema, v.innerContent)
              ]
            ]);
}

function t_decode$2(decoder_dataSchema, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var hLevel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hLevel"), null));
  if (hLevel.TAG === /* Ok */0) {
    var innerContent = Decco.arrayFromJson(decoder_dataSchema, Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerContent"), null));
    if (innerContent.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                hLevel: hLevel._0,
                innerContent: innerContent._0
              }
            };
    }
    var e = innerContent._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".innerContent" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = hLevel._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".hLevel" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function fromHeadlineNode(valueFromDataNode, makeDataSchema, param) {
  return {
          hLevel: param.hLevel,
          innerContent: Belt_Array.map(param.innerContent, Curry._2(DataNodeSchema.fromDataNode, valueFromDataNode, makeDataSchema))
        };
}

function map$2(f, param) {
  return {
          hLevel: param.hLevel,
          innerContent: Belt_Array.map(param.innerContent, f)
        };
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "fromHeadlineNode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    }, HeadlineSchema, {
      t_encode: t_encode$2,
      t_decode: t_decode$2,
      fromHeadlineNode: fromHeadlineNode,
      map: map$2
    });

function t_encode$3(encoder_dataSchema, v) {
  return Js_dict.fromArray([[
                "innerContent",
                Decco.arrayToJson(encoder_dataSchema, v.innerContent)
              ]]);
}

function t_decode$3(decoder_dataSchema, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var innerContent = Decco.arrayFromJson(decoder_dataSchema, Belt_Option.getWithDefault(Js_dict.get(dict._0, "innerContent"), null));
  if (innerContent.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              innerContent: innerContent._0
            }
          };
  }
  var e = innerContent._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".innerContent" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function fromButtonNode(valueFromDataNode, makeDataSchema, param) {
  return {
          innerContent: Belt_Array.map(param.innerContent, Curry._2(DataNodeSchema.fromDataNode, valueFromDataNode, makeDataSchema))
        };
}

function map$3(f, param) {
  return {
          innerContent: Belt_Array.map(param.innerContent, f)
        };
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "fromButtonNode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    }, ButtonSchema, {
      t_encode: t_encode$3,
      t_decode: t_decode$3,
      fromButtonNode: fromButtonNode,
      map: map$3
    });

function t_encode$4(encoder_dataSchema, v) {
  if (typeof v === "number") {
    if (v === /* PlainTexts */0) {
      return ["PlainTexts"];
    } else {
      return ["Images"];
    }
  }
  switch (v.TAG | 0) {
    case /* Links */0 :
        return [
                "Links",
                Curry._2(LinkSchema.t_encode, encoder_dataSchema, v._0)
              ];
    case /* Headlines */1 :
        return [
                "Headlines",
                Curry._2(HeadlineSchema.t_encode, encoder_dataSchema, v._0)
              ];
    case /* Buttons */2 :
        return [
                "Buttons",
                Curry._2(ButtonSchema.t_encode, encoder_dataSchema, v._0)
              ];
    case /* Records */3 :
        return [
                "Records",
                Curry._2(RecordSchema.t_encode, encoder_dataSchema, v._0)
              ];
    
  }
}

function t_decode$4(decoder_dataSchema, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Buttons" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._2(ButtonSchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Buttons */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Headlines" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._2(HeadlineSchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Headlines */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Images" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Images */1
                  };
          }
      case "Links" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Curry._2(LinkSchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Links */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "PlainTexts" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PlainTexts */0
                  };
          }
      case "Records" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Curry._2(RecordSchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Records */3,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function fromArrayNode(valueFromDataNode, makeDataSchema, arrayNode) {
  switch (arrayNode.TAG | 0) {
    case /* PlainTexts */0 :
        return /* PlainTexts */0;
    case /* Images */1 :
        return /* Images */1;
    case /* Links */2 :
        var func = LinkSchema.fromLinkNode;
        var arg = Caml_array.get(arrayNode._0, 0);
        return {
                TAG: /* Links */0,
                _0: (function (param) {
                        var func$1 = Curry._1(func, param);
                        return function (param) {
                          return Curry._2(func$1, param, arg);
                        };
                      })(valueFromDataNode)(makeDataSchema)
              };
    case /* Headlines */3 :
        var func$1 = HeadlineSchema.fromHeadlineNode;
        var arg$1 = Caml_array.get(arrayNode._0, 0);
        return {
                TAG: /* Headlines */1,
                _0: (function (param) {
                        var func$2 = Curry._1(func$1, param);
                        return function (param) {
                          return Curry._2(func$2, param, arg$1);
                        };
                      })(valueFromDataNode)(makeDataSchema)
              };
    case /* Buttons */4 :
        var func$2 = ButtonSchema.fromButtonNode;
        var arg$2 = Caml_array.get(arrayNode._0, 0);
        return {
                TAG: /* Buttons */2,
                _0: (function (param) {
                        var func$3 = Curry._1(func$2, param);
                        return function (param) {
                          return Curry._2(func$3, param, arg$2);
                        };
                      })(valueFromDataNode)(makeDataSchema)
              };
    case /* Records */5 :
        var func$3 = RecordSchema.fromRecord;
        var arg$3 = Caml_array.get(arrayNode._0, 0);
        return {
                TAG: /* Records */3,
                _0: (function (param) {
                        var func$4 = Curry._1(func$3, param);
                        return function (param) {
                          return Curry._2(func$4, param, arg$3);
                        };
                      })(valueFromDataNode)(makeDataSchema)
              };
    
  }
}

function map$4(mapSchema, arraySchema) {
  var f = Curry._1(DataNodeSchema.map, mapSchema);
  if (typeof arraySchema === "number") {
    if (arraySchema === /* PlainTexts */0) {
      return /* PlainTexts */0;
    } else {
      return /* Images */1;
    }
  }
  switch (arraySchema.TAG | 0) {
    case /* Links */0 :
        return {
                TAG: /* Links */0,
                _0: Curry._2(LinkSchema.map, f, arraySchema._0)
              };
    case /* Headlines */1 :
        return {
                TAG: /* Headlines */1,
                _0: Curry._2(HeadlineSchema.map, f, arraySchema._0)
              };
    case /* Buttons */2 :
        return {
                TAG: /* Buttons */2,
                _0: Curry._2(ButtonSchema.map, f, arraySchema._0)
              };
    case /* Records */3 :
        return {
                TAG: /* Records */3,
                _0: Curry._2(RecordSchema.map, f, arraySchema._0)
              };
    
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "fromArrayNode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    }, ArraySchema, {
      t_encode: t_encode$4,
      t_decode: t_decode$4,
      fromArrayNode: fromArrayNode,
      map: map$4
    });

function t_encode$5(encoder_dataSchema, v) {
  return Js_dict.fromArray([
              [
                "friendlyName",
                Decco.optionToJson(Decco.stringToJson, v.friendlyName)
              ],
              [
                "properties",
                Decco.arrayToJson(Curry._1(RecordPropertySchema.t_encode, encoder_dataSchema), v.properties)
              ]
            ]);
}

function t_decode$5(decoder_dataSchema, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var friendlyName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "friendlyName"), null));
  if (friendlyName.TAG === /* Ok */0) {
    var properties = Decco.arrayFromJson(Curry._1(RecordPropertySchema.t_decode, decoder_dataSchema), Belt_Option.getWithDefault(Js_dict.get(dict$1, "properties"), null));
    if (properties.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                friendlyName: friendlyName._0,
                properties: properties._0
              }
            };
    }
    var e = properties._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".properties" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = friendlyName._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".friendlyName" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function fromRecord(valueFromDataNode, makeDataSchema, param) {
  return {
          friendlyName: param.friendlyName,
          properties: Belt_Array.map(param.properties, Curry._2(RecordPropertySchema.fromProperty, valueFromDataNode, makeDataSchema))
        };
}

function map$5(f, param) {
  return {
          friendlyName: param.friendlyName,
          properties: Belt_Array.map(param.properties, (function (param) {
                  return {
                          friendlyName: param.friendlyName,
                          dataSchema: Curry._1(f, param.dataSchema)
                        };
                }))
        };
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "fromRecord"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    }, RecordSchema, {
      t_encode: t_encode$5,
      t_decode: t_decode$5,
      fromRecord: fromRecord,
      map: map$5
    });

var DataNodePath;

exports.EdgeCases = EdgeCases;
exports.RecordPropertySchema = RecordPropertySchema;
exports.DataNodePath = DataNodePath;
exports.DataNodeSchema = DataNodeSchema;
exports.LinkSchema = LinkSchema;
exports.HeadlineSchema = HeadlineSchema;
exports.ButtonSchema = ButtonSchema;
exports.ArraySchema = ArraySchema;
exports.RecordSchema = RecordSchema;
/* RecordPropertySchema Not a pure module */
